import Image from 'next/legacy/image';
import React from 'react';

import Container from './Container';
import Wrapper from './Wrapper';

export type LogoProps = {
  image: string;
};

const Logo: React.FC<LogoProps> = ({ image }) => {
  return (
    <Wrapper>
      <Container>
        <Image
          src={image}
          alt={image}
          width={71}
          height={59}
          quality={100}
          objectFit='contain'
        />
      </Container>
    </Wrapper>
  );
};

export default Logo;
